import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ScubaOWNewPage from '../pages/ScubaOW/new'

export default function ScubaOWRoutes() {
  return (
    <Switch>
      <Route path="/scuba_ow/new" component={ScubaOWNewPage} />
    </Switch>
  )
}
